<template>
  <div class="header">
    <div class="wrap h">
      <div class="logo">
        <!--  -->
        <img :src="domian + logo" alt="" @click="goPage(0, '/', '首页', '')" />
      </div>
      <div class="nav">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            @mouseover="handleOver(index)"
            @click="goPage(index, item.url, item.title, '')"
            :class="index == curretnNavIdx ? 'active' : ''"
          >
            {{ item.title }}
          </li>
          <!-- <li @click="goPage(0)" :class="curretnNavIdx == 0 ?'active':''">首页</li>
          <li @click="goPage(1)" :class="curretnNavIdx == 1 ?'active':''">解决方案</li>
          <li @click="goPage(2)" :class="curretnNavIdx == 2 ?'active':''">产品中心</li>
          <li @click="goPage(3)" :class="curretnNavIdx == 3 ?'active':''">新闻动态</li>
          <li @click="goPage(4)" :class="curretnNavIdx == 4 ?'active':''">关于我们</li> -->
        </ul>
      </div>
    </div>
    <!-- 方案 -->
    <div
      class="nav-detail"
      v-show="isShowDetailNav"
      @mouseleave="handleLeave()"
    >
      <div class="wrap">
        <div class="nav-title">全部解决方案</div>
        <div class="detail">
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_zhws@2x.png" alt="" />
                智慧卫生
              </dt>
              <dd
                v-for="item in planList['zhw']"
                :key="item.id"
                @click="goPage(1, '/plan', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_zhys@2x.png" alt="" />
                智慧医院
              </dt>
              <dd
                v-for="item in planList['zhy']"
                :key="item.id"
                @click="goPage(1, '/plan', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_zhfw@2x.png" alt="" />
                智慧服务
              </dt>
              <dd
                v-for="item in planList['zhf']"
                :key="item.id"
                @click="goPage(1, '/plan', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品 -->
    <div
      class="nav-detail"
      v-show="isShowProductNav"
      @mouseleave="handleLeave()"
    >
      <div class="wrap">
        <div class="nav-title">全部产品</div>
        <div class="detail">
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_zhws@2x.png" alt="" />
                家庭签约随访
              </dt>
              <dd
                v-for="item in productList['zhw']"
                :key="item.id"
                @click="goPage(2, '/separate', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_gwct@2x.png" alt="" />
                公卫查体
              </dt>
              <dd
                v-for="item in productList['gwct']"
                :key="item.id"
                @click="goPage(2, '/separate', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
          <div class="item">
            <dl>
              <dt>
                <img src="../assets/img/icon/icon_jkyz@2x.png" alt="" />
                健康驿站
              </dt>
              <dd
                v-for="item in productList['jkyz']"
                :key="item.id"
                @click="goPage(2, '/separate', item.title, item.id)"
              >
                {{ item.title }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { solutionHeader, productHeader, setting } from "../network/http_api";
import { BASEDOMAIN } from "../common/config";

export default {
  data() {
    return {
      domian: "",
      logo: "",
      curretnNavIdx: 0,
      isShowDetailNav: false,
      isShowProductNav: false,
      navList: ["首页", "解决方案", "产品中心", "新闻动态", "关于我们"],
      planList: {
        zhw: [],
        zhy: [],
        zhf: [],
      },
      productList: {
        zhw: [],
        gwct: [],
        jkyz: [],
      },
    };
  },
  mounted() {
    this.domian = BASEDOMAIN;
    this.$bus.$on("headerIdx", (res) => {
      //console.log("res", res);
      this.curretnNavIdx = res;
    });
    //console.log("...");
    let res = window.sessionStorage.getItem("cnav");
    if (res) {
      this.curretnNavIdx = res;
    }
    this.getData();
    this.getheader();
    this.product();
  },
  methods: {
    async getData() {
      let res = await setting();
      if (res.code == 200) {
        this.navList = JSON.parse(res.data.model_setting);
        this.logo = res.data.logo;
        //console.log("headers", this.navList);
      } else {
        this.$message.error(res.msg);
      }
    },
    async getheader() {
      let res = await solutionHeader();
      //console.log("headleRes", res);
      if (res.code == 200) {
        this.planList.zhw = res.data[1];
        this.planList.zhy = res.data[2];
        this.planList.zhf = res.data[3];
      } else {
        this.$message.error(res.msg);
      }
      //console.log("getheader", res);
    },
    async product() {
      let res = await productHeader();
      if (res.code == 200) {
        this.productList.zhw = res.data[1];
        this.productList.gwct = res.data[2];
        this.productList.jkyz = res.data[3];
      } else {
        this.$message.error(res.msg);
      }
      //console.log("productList", this.productList);
    },
    goPage(idx, path = "", title = "", item_id) {
      //console.log("🥴idx", idx);
      //console.log("🥴path", path);
      //console.log("🥴title", title);
      //console.log("🥴item_id", item_id);
      if ((idx == 1 || idx == 2) && path == "") {
      } else {
        this.curretnNavIdx = idx;
      }

      if (path == "") {
        //console.log('this',path);
      } else {
        if (item_id == "") {
          // console.log("this", this.$route);
          if (this.$route.path == path) {
          } else {
            this.$router.push(path);
          }
        } else {
          if (this.$route.path == path && this.$route.query.item_id == item_id) {
          } else {
            this.$router.push({
              path: path,
              query: {
                item_id,
              },
            });
          }
        }
      }

      document.title = title;
      window.sessionStorage.setItem("cnav", this.curretnNavIdx);
    },
    // goPage(idx, path = "", title = "") {
    //   //console.log(idx, path);
    //   if ((idx == 1 || idx == 2) && path == "") {
    //   } else {
    //     this.curretnNavIdx = idx;
    //   }
    //   if (idx == 0) {
    //     this.$router.push("/");
    //     document.title = "鸢飞信息科技";
    //   } else if (idx == 3) {
    //     this.$router.push("/news");
    //     document.title = "新闻动态";
    //   } else if (idx == 4) {
    //     this.$router.push("/about");
    //     document.title = "关于我们";
    //   } else if ((idx == 1 || idx == 2) && path != "") {
    //     this.$router.push(path);
    //     document.title = `解决方案—${title}`;
    //   }
    //   window.sessionStorage.setItem("cnav", this.curretnNavIdx);
    // },
    handleOver(idx) {
      //console.log(idx);
      if (idx == 1) {
        this.isShowDetailNav = true;
        this.isShowProductNav = false;
      } else if (idx == 2) {
        this.isShowProductNav = true;
        this.isShowDetailNav = false;
      } else {
        this.isShowDetailNav = false;
        this.isShowProductNav = false;
      }
    },
    handleLeave() {
      this.isShowDetailNav = false;
      this.isShowProductNav = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  z-index: 9;
  color: #fff;
  .wrap {
    display: flex;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .logo {
      width: 100px;
      height: 40px;
      margin: 12px;
      //   background: black;
      margin-right: 100px;
      // cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .nav {
      ul {
        display: flex;
        top: 0;
        height: 100%;
      }
      li {
        height: 62px;
        line-height: 62px;
        padding: 0 8px;
        margin-right: 45px;
        cursor: pointer;
        border-bottom: 2px solid transparent;
      }
      li:hover {
        color: #1d7bff;
        border-bottom: 2px solid #1d7bff;
      }
      .active {
        color: #1d7bff;
        border-bottom: 2px solid #1d7bff;
      }
    }
  }
  .nav-detail {
    position: absolute;
    top: 64px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.27);
    .wrap {
      display: flex;
      align-items: center;
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
    }
    .nav-title {
      padding-right: 26px;
    }
    .detail {
      flex: 1;
      display: flex;

      border-left: 1px solid #a7aab0;
      .item {
        margin: 0 26px;
        width: 165px;
        dt {
          display: flex;
          padding: 10px 0;
          border-bottom: 1px solid #a7aab0;
          margin-bottom: 15px;
          img {
            width: 18px;
            margin-right: 7px;
          }
        }
        dd {
          margin: 15px 0;
          cursor: pointer;
        }
        dd:hover {
          color: #1d7bff;
        }
        .active-d {
          color: #1d7bff;
        }
      }
    }
  }
}
.header:hover {
  color: #000;
  background-color: #fff;
}
</style>